import { render, staticRenderFns } from "./HotSearchDialog.vue?vue&type=template&id=634a38d0&scoped=true"
import script from "./HotSearchDialog.vue?vue&type=script&lang=js"
export * from "./HotSearchDialog.vue?vue&type=script&lang=js"
import style0 from "./HotSearchDialog.vue?vue&type=style&index=0&id=634a38d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634a38d0",
  null
  
)

export default component.exports